var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickshare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.111,
    height: 12.111,
    viewBox: "0 0 12.111 12.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_2_",
    "data-name": "open (2)",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    d: "M16.766,16.766H7.346V7.346h4.71V6H7.346A1.345,1.345,0,0,0,6,7.346v9.42a1.345,1.345,0,0,0,1.346,1.346h9.42a1.345,1.345,0,0,0,1.346-1.346v-4.71H16.766ZM13.4,6V7.346h2.412L9.2,13.96l.952.952L16.766,8.3V10.71h1.346V6Z",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickshare);
export default __webpack_public_path__ + "static/media/quickshare.184395d668410529d6a1d1ed67263f34.svg";
export { ForwardRef as ReactComponent };